import { render, staticRenderFns } from "./Saving.vue?vue&type=template&id=099d3672&"
var script = {}
import style0 from "./Saving.vue?vue&type=style&index=0&id=099d3672&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports